export const common = {
  namespaced: true,
  state: {
    ip: process.env.VUE_APP_SERVER_IP || "https://demo.dgelec.kr",
    // STOMP(SockJS) 접속 주소. nginx 가 /stomp/ 를 백엔드로 넘기므로 포트 없이 쓴다
    wsUrl: process.env.VUE_APP_WS_URL || `${process.env.VUE_APP_SERVER_IP || "https://demo.dgelec.kr"}/stomp/chat`,
    // ip: "http://192.168.10.10",
    // ip: "http://192.168.150.166",
    // ip: "http://192.168.35.103",
    productCodes: [], // 제품 목록
    materials:[],
    isMobile: false,
  },
  mutations: {
  },
};
